import { createSlice } from "@reduxjs/toolkit";

const getCartTotal = (items) =>
  items.reduce((sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0), 0);

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    items: [],
    total: 0,
  },
  reducers: {
    addToCart: (state, action) => {
      const payload = action.payload;
      const existingItem = state.items.find((item) => item.id === payload.id);

      if (existingItem) {
        existingItem.quantity += Number(payload.quantity || 1);
      } else {
        state.items.push({ ...payload, quantity: Number(payload.quantity || 1) });
      }

      state.total = getCartTotal(state.items);
    },
    removeFromCart: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
      state.total = getCartTotal(state.items);
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const item = state.items.find((item) => item.id === id);

      if (item) {
        item.quantity = Number(quantity || 0);
        if (item.quantity <= 0) {
          state.items = state.items.filter((cartItem) => cartItem.id !== id);
        }
      }

      state.total = getCartTotal(state.items);
    },
    clearCart: (state) => {
      state.items = [];
      state.total = 0;
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
